export const PARTNER_REGISTER_URL = 'https://partner.egbaffiliates.com/dashboard/register';
export const PARTNER_LOGIN_URL = 'https://partner.egbaffiliates.com/dashboard/login';
export const PARTNER_TELEGRAM_URL = 'https://t.me/iboom67';
export const PARTNER_EMAIL = 'support@egb.com';
